module.exports = __webpack_public_path__ + "static/img/care-1.0fc3041.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/care-1.png
// module id = Jysz
// module chunks = 1